import script from "./UiRightPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiRightPanel.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__